<span class="wrapper">
    {{ unitPrice() }}

    @if (energyEfficiencyClass()) {
        <app-svg-icon class="class-energy"
                      [iconName]="'class_arrows_ag_'+ (energyEfficiencyClass() | lowercase)"></app-svg-icon>
    }
</span>

@if (energyEfficiencyProductSheetURL()) {
    <a class="kk-link kk-hover-underline text-color-black" rel="noreferrer nofallow" target="_blank"
       [href]="energyEfficiencyProductSheetURL()">{{ 'productPrices.energyEfficiencyProductSheetUrl' | translateSafe }}</a>
}

